import React, { useState, useEffect } from 'react';
import PrizeWheel from './prizeWheel';
import { usePrizeWheelController } from './prizeWheelController';

const PrizeWheelGame = () => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');
  const [canSpin, setCanSpin] = useState(true);
  const [items, setItems] = useState([]);

  const getPrizeIndex = (prizeName) => {
    const prizes = [
      "Small Prize",
      "No Prize",
      "Small Prize",
      "Huge Prize",
      "No Prize",
      "Big Prize",
      "No Prize",
      "Medium Prize"
    ];
    return prizes.indexOf(prizeName);
  };

  useEffect(() => {
    checkSpinAvailability();
  }, []);

  const checkSpinAvailability = () => {
    const lastSpinTime = localStorage.getItem('lastSpinTime');
    if (lastSpinTime) {
      const twentyFourHours = 24 * 60 * 60 * 1000;
      const timeSinceLastSpin = Date.now() - parseInt(lastSpinTime, 10);
      
      if (timeSinceLastSpin < twentyFourHours) {
        setCanSpin(false);
        const hoursLeft = Math.ceil((twentyFourHours - timeSinceLastSpin) / (60 * 60 * 1000));
        setDisplayMessage(`You can spin again in ${hoursLeft} hours`);
      } else {
        setCanSpin(true);
      }
    } else {
      setCanSpin(true);
    }
  };

  const handleSpinClick = async () => {
    if (isSpinning || !canSpin) return;

    setIsSpinning(true);
    const targetIndex = await fetchResponseAndGetPrizeIndex();
    console.log('targetIndex', targetIndex);
    
    if (targetIndex !== null) {
      controller.spin(targetIndex);
      // Store the current time in localStorage
      localStorage.setItem('lastSpinTime', Date.now().toString());
      setCanSpin(false);
    }

    setTimeout(() => {
      setIsSpinning(false);
    }, 3000);
  };


  const fetchResponseAndGetPrizeIndex = async () => {
    // Simulate API call
    const response = await simulateWinResponse();
    console.log('API response:', response);
    if (response) {
      const cashbackAmount = response.cashbackAmount || 0;
      const winningFlag = response.winningFlag || false;
      let targetPrizeIndex;

      if (!winningFlag) {
        targetPrizeIndex = getPrizeIndex("No Prize");
      } else if (cashbackAmount === 15) {
        targetPrizeIndex = getPrizeIndex("Small Prize");
      } else if (cashbackAmount === 35) {
        targetPrizeIndex = getPrizeIndex("Medium Prize");
      } else if (cashbackAmount === 78) {
        targetPrizeIndex = getPrizeIndex("Huge Prize");
      } else {
        targetPrizeIndex = getPrizeIndex("Big Prize");
      }

      setItems([
        { probability: 1.0, rewardAED: 15 },
        { probability: 1.0, rewardAED: 0 },
        { probability: 1.0, rewardAED: 15 },
        { probability: 1.0, rewardAED: 78 },
        { probability: 1.0, rewardAED: 0 },
        { probability: 1.0, rewardAED: 35 },
        { probability: 1.0, rewardAED: 0 },
        { probability: 1.0, rewardAED: 25 },
      ]);

      return targetPrizeIndex;
    }
    return null;
  };

  const simulateWinResponse = () => {
    // Simulate random win/loss with different prize amounts
    const randomWin = Math.random() > 0.5;
    const prizeAmounts = [0, 15, 25, 35, 78];
    const randomAmount = prizeAmounts[Math.floor(Math.random() * prizeAmounts.length)];
    
    return {
      winningFlag: randomWin && randomAmount !== 0,
      cashbackAmount: randomAmount,
      message: randomWin ? "You won a prize!" : "Better luck next time!"
    };
  };

  const handleSpinEnd = (selectedItem) => {
    if (selectedItem.rewardAED === 0 || selectedItem.rewardAED === null) {
      // No prize
      playSound('lost');
      setDisplayMessage("Better luck next time!");
    } else {
      // Won prize
      playSound('won');
      setDisplayMessage(`🎉 Congratulations! You won ${selectedItem.rewardAED} AED!`);
      printReceipt(selectedItem.rewardAED);
    }
  };

  const playSound = (type) => {
    // Implement sound playing logic
    console.log(`Playing ${type} sound`);
  };

  const printReceipt = (amount) => {
    // Implement receipt printing logic
    console.log(`Printing receipt for ${amount} AED`);
  };

  const controller = usePrizeWheelController(items, handleSpinEnd);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #4b6cb7 0%, #182848 100%)',
      padding: '20px',
      color: 'white',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '40px' }}>
        Spin The Wheel And Win Crazy Deals
      </h1>
      
      <div style={{ 
        height: '400px',
        margin: '0 auto',
        maxWidth: '500px',
        position: 'relative'
      }}>
        <PrizeWheel controller={controller} items={items} />
      </div>

      <div style={{ margin: '40px 0' }}>
        <button
          onClick={handleSpinClick}
          disabled={isSpinning || !canSpin}
          style={{
            backgroundColor: (!canSpin || isSpinning) ? '#cccccc' : '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '15px 32px',
            textAlign: 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '16px',
            margin: '4px 2px',
            cursor: isSpinning ? 'not-allowed' : 'pointer',
            borderRadius: '8px',
            fontWeight: 'bold',
            opacity: isSpinning ? 0.7 : 1,
            transition: 'all 0.3s ease'
          }}
        >
         {!canSpin ? 'Come back tomorrow' : 
         isSpinning ? 'Spinning...' : 'Spin The Wheel'}
        </button>

      </div>

      {displayMessage && (
        <div style={{
          fontSize: '20px',
          fontWeight: 'bold',
          margin: '20px 0',
          minHeight: '60px'
        }}>
          {displayMessage}
        </div>
      )}
    </div>
  );
};

export default PrizeWheelGame;